module.exports = __webpack_public_path__ + "fonts/MyriadPro-Cond.5116968.ttf";